if (typeof complementaryProductsComponent === 'undefined') {
    class ComplementaryProductsComponent extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const url = this.dataset.url;
            this.buildProducts(url);
        }

        async buildProducts(url) {
            const res = await fetch(url);
            let text = await res.text();

            const html = document.createElement('div');
            text = text.replaceAll('variant-selects', 'div').replaceAll('variant-radios', 'div').replaceAll('product-tab', 'div').replaceAll('compare-color', 'div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[data-complementary-product]');
            if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;

                if (window.sharedFunctions.checkNeedToConvertCurrency()) {
                    Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                }
            }

            const productCarousel = this.querySelector('.products-carousel');
            this.initializeSlider(productCarousel);
            this.initComplementaryProductsSelection();
        }

        initializeSlider(productCarousel = null) {
            if (productCarousel) {
                const itemArrows = productCarousel.dataset.itemArrows === 'true';
                const itemDots = productCarousel.dataset.itemDots === 'true';
                const itemRows = parseInt(productCarousel.dataset.itemRows);
                const itemToShow = parseInt(productCarousel.dataset.itemToShow);
                const complementaryStyle = this.classList.contains('style-1');

                $(productCarousel).on('init', () => {
                    this.calculateCard06Padding();
                });

                if (!productCarousel.classList.contains('slick-slider')) {
                    $(productCarousel).slick({
                        dots: itemDots,
                        arrows: itemArrows,
                        slidesToShow: complementaryStyle ? itemToShow : 1,
                        rows: !complementaryStyle ? itemRows : 1,
                        slidesToScroll: 1,
                        slidesPerRow: 1,
                        infinite: true,
                        rtl: window.rtl_slick,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        responsive: [
                            {
                                breakpoint: 1025,
                                settings: {
                                    slidesToShow: complementaryStyle ? 2 : 1
                                }
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: complementaryStyle ? 2 : 1
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: complementaryStyle ? 2 : 1
                                }
                            },
                            {
                                breakpoint: 321,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });
                }
            }
        }

        calculateCard06Padding() {
            if (!document.body.classList.contains('product-card-layout-06')) return;

            const selectOptionsHeight = this.querySelector('.product .card-action').scrollHeight;
            this.querySelector('.slick-list').style.paddingBottom = selectOptionsHeight + 'px';
        }

        initComplementaryProductsSelection() {
            window.complementaryQueue = [];

            document.querySelectorAll('complementary-products .product').forEach(product => {
                product.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    // Previne que o select desselecione o card
                    if ($(event.target).is('select')) return;

                    const isChecked = $(product).hasClass('checked');
                    const productId = $($(product).children()[0]).data('product-id').split('-')[1];
                    const selectedOptions = {};

                    product.querySelectorAll('.variant-option').forEach(optionSelect => {
                        const optionName = optionSelect.getAttribute('data-option-name');
                        selectedOptions[optionName] = optionSelect.value;
                    });

                    const beforeChangeId = document.querySelector(`#complementary-master-selector-${productId}`).value;
                    const index = window.complementaryQueue.indexOf(+beforeChangeId);

                    //Retira o id da array caso este esteja marcado
                    if (isChecked) {
                        $(product).removeClass('checked');
                        window.complementaryQueue = window.complementaryQueue.filter(item => item !== +beforeChangeId);
                        return;
                    }

                    const selectedVariantId = this.updateVariant(productId, selectedOptions);
                    if (selectedVariantId) {
                        if (index === -1) {
                            window.complementaryQueue.push(selectedVariantId);
                        } else {
                            window.complementaryQueue[index] = selectedVariantId;
                        }

                        console.log(window.complementaryQueue);

                        document.querySelector(`#complementary-master-selector-${productId}`).value = selectedVariantId;
                        $(product).addClass('checked');
                        console.log('Test: ', document.querySelector(`#complementary-master-selector-${productId}`).value);
                    }
                });

                // Adicionando event listeners para os selects
                product.querySelectorAll('.variant-option').forEach(select => {
                    select.addEventListener('change', (event) => {
                        const productId = $($(product).children()[0]).data('product-id').split('-')[1];
                        const selectedOptions = {};
                        const isChecked = $(product).hasClass('checked');

                        product.querySelectorAll('.variant-option').forEach(optionSelect => {
                            const optionName = optionSelect.getAttribute('data-option-name');
                            selectedOptions[optionName] = optionSelect.value;
                        });

                        const beforeChangeId = document.querySelector(`#complementary-master-selector-${productId}`).value;
                        const selectedVariantId = this.updateVariant(productId, selectedOptions);

                        const index = window.complementaryQueue.indexOf(+beforeChangeId);

                        if (!isChecked) $(product).addClass('checked');

                        if (selectedVariantId) {
                            if (index === -1) {
                                window.complementaryQueue.push(selectedVariantId);
                            } else {
                                window.complementaryQueue[index] = selectedVariantId;
                            }
                        }

                        console.log('Test: ', document.querySelector(`#complementary-master-selector-${productId}`).value);

                    });
                });
            });
        }

        updateVariant(productId, selectedOptions) {
            var productElement = document.querySelector(`[data-product-id="product-${productId}"]`);
            var productData = JSON.parse(productElement.getAttribute('data-json-product'));
            var variants = productData.variants;
            var selectedVariant = this.findVariant(variants, selectedOptions);

            if (selectedVariant) {
                console.log('Selected Variant ID:', selectedVariant.id);
                document.querySelector(`#complementary-master-selector-${productId}`).value = selectedVariant.id;
                return selectedVariant.id;
            } else {
                return null;
            }
        }

        findVariant(variants, selectedOptions) {
            return variants.find(function (variant) {
                return Object.keys(selectedOptions).every(function (optionName, index) {
                    return variant[`option${index + 1}`] === selectedOptions[optionName];
                });
            });
        }
    }

    window.addEventListener('load', () => {
        customElements.define('complementary-products', ComplementaryProductsComponent);
    });

    var complementaryProductsComponent = ComplementaryProductsComponent;
}
